import { get, isUndefined, reduce, last, each, isObject, indexOf, cloneDeep } from 'lodash';
import debug from 'debug';
const log = debug('itp:core:openapi-tools');
export function getReference(doc, path) {
    if (!path.startsWith('#')) {
        throw new Error(`Invalid $ref path. It must start with "#" character. path=${path}`);
    }
    let result = get(doc, path.split('/').slice(1));
    if (!result) {
        throw new Error(`$ref not found: ${path}`);
    }
    return result;
}
export function valueAs(doc, data) {
    if (get(data, '$ref', null) !== null) {
        return getReference(doc, data.$ref);
    }
    return data;
}
export function defaultValue(doc, obj) {
    if (!isUndefined(obj.default)) {
        return obj.default;
    }
    if (obj.type === 'object') {
        return defaultsFromSchema(doc, obj);
    }
    if (obj.type === 'array') {
        return [];
    }
    return null;
}
function defaultsFromSchema(doc, schema) {
    return reduce(schema.properties, (m, v, k) => ((m[k] = defaultValue(doc, valueAs(doc, v))), m), {});
}
export const getSchemaDefaults = (doc, schema) => defaultsFromSchema(doc, schema);
export function getOperation(doc, operationId) {
    if (operationId.indexOf('/') > -1) {
        const lastToken = last(operationId.split('/'));
        if (lastToken) {
            operationId = lastToken;
        }
    }
    let result = null;
    each(doc.paths, (pathItem, url) => {
        each(pathItem, (op, method) => {
            if (get(op, 'operationId') === operationId) {
                result = op;
            }
        });
    });
    if (!result) {
        throw new Error(`invalid OpenAPI operationId: ${operationId}`);
    }
    return result;
}
export function getSchema(doc, name) {
    let result;
    const key = last(name.split('/'));
    if (isObject(doc.components) &&
        isObject(doc.components.schemas) &&
        key in doc.components.schemas) {
        result = valueAs(doc, doc.components.schemas[key]);
    }
    if (isUndefined(result)) {
        throw new Error(`OpenAPI schema not found: ${name}`);
    }
    return result;
}
export function hasProperty(schema, name) {
    return !!(schema.properties && name in schema.properties);
}
function getProperty(doc, schema, name) {
    let result;
    if (schema.properties && name in schema.properties) {
        result = valueAs(doc, schema.properties[name]);
    }
    if (!result) {
        throw new Error(`OpenAPI property not found: ${name}. (schema=${schema.title ||
            schema.description})`);
    }
    return result;
}
export function getPropertyRules(doc, schema, property) {
    const sch = getSchema(doc, schema);
    if (!hasProperty(sch, property)) {
        return { readonly: true };
    }
    const prop = getProperty(doc, sch, property);
    const result = {};
    if (prop.maximum != null) {
        result['max_value'] = prop.maximum;
    }
    if (prop.minimum != null) {
        result['min_value'] = prop.minimum;
    }
    if (prop.maxLength != null) {
        result['max'] = prop.maxLength;
    }
    if (prop.minLength != null) {
        result['min'] = prop.minLength;
    }
    if (indexOf(sch.required, property) > -1) {
        result['required'] = true;
    }
    if (prop.enum) {
        result['oneOf'] = cloneDeep(prop.enum);
    }
    return result;
}
//# sourceMappingURL=openapi-tools.js.map